import { QBankStructureCVList } from '@exam-management/qbank-structure-cv-list';
import { type UserRow, UserCard } from '@exam-management/user-management';
import { type BoxProps, Box, Flex } from '@shared/components';

interface QBankStructureCvListWithSelectedUsersFormProps extends BoxProps {
  usersDetails: UserRow[];
  disabled?: boolean;
}

export function QBankStructureCvListWithSelectedUsersForm(
  props: Readonly<QBankStructureCvListWithSelectedUsersFormProps>,
) {
  const { usersDetails, disabled: isDisabled = false, ...restProps } = props;

  return (
    <Box {...restProps}>
      <Flex sx={(theme) => ({ gap: theme.spacing(4), flexWrap: 'wrap', mb: theme.spacing(6) })}>
        {usersDetails.map((user) => {
          const { profile, appRoles } = user;
          return <UserCard key={user.userId} {...profile} roles={appRoles} />;
        })}
      </Flex>
      <QBankStructureCVList disabled={isDisabled} />
    </Box>
  );
}
